export const mainColumnGridSizes = {
  xs: 12,
  md: 8
};

export const sectionVerticalPadding = "40px";
